//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getPlacesNow, getPlacesTotal } from '@/utils/event/members';

export default {
  data() {
    return {
      placesNow: 0,
      placesTotal: 0,
    };
  },
  computed: {
    event() {
      return this.$store.state.event.data;
    },
    places() {
      const now = this.placesNow;
      const total = this.placesTotal;
      const line = 'eventos.register.type.places';

      return this.$t(line, {
        now,
        total,
      });
    },
  },
  created() {
    const placesNow = getPlacesNow(this.event);
    const placesTotal = getPlacesTotal(placesNow);

    this.placesNow = placesNow;
    this.placesTotal = placesTotal;
  },
};
